import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { ResponsibleData } from 'shell/models/type-responsible';
import { FormResponsibleVM } from 'practice/components/resonsible/form';

export const responsibleResponseTransformer = (
  response: AxiosResponse<HttpResponse<ResponsibleData>>
): FormResponsibleVM => {
  const { data } = response;
  const item = data.payload;
  return {
    practice: item.key?.tipoPratica || '',
    responsible: item.codResponsabile || '',
    service: item.key?.codServizio || '',
  };
};
